export default __webpack_public_path__ + "static/media/TS-rough-mock-3.48ad21c3.jpg";